import { useDuplicateRelationship } from "../../useDuplicateRelationship";
import { useStoreActions } from "../../../store/store-context";
import { useMutationState } from "../useMutationState";
import { pathgen } from 'object-path-generator';
export const useDraftProposalTestIds = pathgen('useDraftProposalTestIds');
export const useDraftProposal = function useDraftProposal() {
  let {
    onSuccess,
    withPageLoader = true,
    biCode
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    api
  } = useStoreActions();
  const {
    createDraftFromRelationship
  } = useDuplicateRelationship();
  const {
    mutate,
    isLoading
  } = useMutationState({
    mutationFn: async _ref => {
      let {
        draftId,
        relationshipId
      } = _ref;
      let newDraftId;
      if (draftId) {
        newDraftId = await api.draft.duplicate(draftId);
      } else {
        newDraftId = await createDraftFromRelationship(relationshipId, {
          strategy: 'withdraw-to-edit'
        });
      }
      await api.relationship.cancelProposal(relationshipId);
      return newDraftId;
    },
    onSuccess,
    withPageLoader,
    biCode,
    toasts: {
      successMessage: 'Proposal moved to drafts successfully',
      successTestId: useDraftProposalTestIds.SuccessToast(),
      errorMessage: 'Failed to move proposal to drafts',
      errorTestId: useDraftProposalTestIds.ErrorToast()
    }
  });
  return {
    draftProposal: mutate,
    isLoading
  };
};